<!-- 公共menu菜单 -->
<template>
  <div>
    <div class="head" :style="'background-color:' + bg">
      <!-- logo -->
      <div class="head-logo">
        <img src="../../assets/img/logo.png"/>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Menu,
  MenuItem,
  Button,
  Row,
  Col,
  Icon
} from 'element-ui'
export default {
  data () {
    return {
      navlist: [
        //   {
        //   path: '/sponsor',
        //   navItem: '赞助'
        // },
        {
          path: '/',
          navItem: '首页'
        },
        // {
        //   path: '/activity',
        //   navItem: '第二课堂精品活动库'
        // },
        {
          path: '/parttime',
          navItem: '校招伴侣'
        },
        // , {
        //   name: '',
        //   navItem: '实习'
        // }, {
        //   name: '',
        //   navItem: '招聘'
        // },
        {
          path: '/exam',
          navItem: '大学生数据研究院'
        },
        // 新增（2020-05-04）
        // {
        //   path: '/about',
        //   navItem: '关于我们'
        // },
        // {
        //   path: '/contact',
        //   navItem: '联系我们'
        // },
        {
          path: '/help',
          navItem: '政策新闻库'
        },
        {
          path: '/youth',
          navItem: '创青春'
        }
        // {
        //   path: '/opinion',
        //   navItem: '意见与建议'
        // }
      ],
      islogin: false
    }
  },
  components: {
    'el-menu': Menu,
    'el-menu-item': MenuItem,
    'el-button': Button,
    'el-row': Row,
    'el-col': Col,
    'el-icon': Icon
  },
  props: ['bg'],
  created () {
    // this.getUserInfo()
  },
  methods: {
    tomanage () {
      let host = window.location // www.daomengs.com
      if (host.hostname === 'www.daomengs.com') {
        window.open(host.protocol + '//console.daomengs.com')
      } else {
        window.open(host.protocol + '//' + host.hostname + ':10610')
      }
    },
    tootherpage (path) {
      // this.$router.push({
      //   path: path
      // })
      let host = window.location // www.daomengs.com
      if (host.hostname === 'www.daomengs.com') {
        window.open(host.protocol + '//console.daomengs.com' + path)
      } else {
        window.open(host.protocol + '//' + host.hostname + ':10610' + path)
      }
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    getUserInfo () {
      this.$http({
        method: 'POST',
        url: '/user/info'
      }).then(res => {
        if (res.code === 100 || res.code === '100') {
          this.userInfo.loginName = res.result.loginName
          this.userInfo.logoPath = res.result.logoPath
          this.islogin = true
        } else {
          this.islogin = false
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style lang="scss">
.head {
  width: 100%;
  min-width: 1200px;
  // min-width: 1400px;
  border-bottom: 1px solid rgba(61, 60, 65, 0.5);
  background-color: rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: start;
  .head-logo {
    padding-left: 17.5%;
    margin: 0;
    text-align: left;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: start;
    img {
      height: 25px;
    }
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
    outline: none;
    color: #2873ff;
    background-color: inherit;
  }
}
.head-userinfo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #fff;
  font-size: 12px;
  height: 61px;
}
.head-userinfo img {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  box-shadow: 0 0 6px -2px #eee;
  margin-left: 10px;
}
.head-userinfo .logoutBtn {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url("../../assets/img/logoutB.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin-left: 35px;
  cursor: pointer;
}
.userinfo-operatebox {
  padding: 0;
  border-radius: 5px;
  margin-right: 20px;
}
.userinfo-operatebox .userinfo-operate-item {
  padding: 15px;
  font-size: 14px;
  white-space: nowrap;
  color: #666666;
}
.userinfo-operatebox
  .userinfo-operate
  .userinfo-operate-item.userinfo-operate-logout {
  color: #666666;
  padding: 15px;
  border-top: 1px solid #cccccc;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}
.userinfo-operatebox .userinfo-operate .userinfo-operate-logout:before {
  margin-right: 5px;
}
.userinfo-operatebox .userinfo-operate .userinfo-operate-logout:hover {
  color: #2873ff;
}

.icon-logo {
  height: 20px;
  width: 20px;
  background-image: url(../../assets/logo.png);
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue